import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
@Component({
  selector: 'app-datepicker',
  standalone: true,
  imports: [CommonModule, FormsModule, CalendarModule],
  templateUrl: './datepicker.component.html',
  styleUrl: './datepicker.component.scss'
})
export class DatepickerComponent {
  @Input () selectedDate: Date | undefined;
  @Input () isViewApo: boolean = false;
  @Output() dateChange : EventEmitter<Date> = new EventEmitter<Date>();
  es: any;
  constructor() {
  }

  ngOnInit() {

  }

  onDateChange(date: Date) {
    this.selectedDate = date;
    this.dateChange.emit(date);
  }


}
